`<template>
	<div class="checkbox">
      <input
        type="checkbox"
        :id="id"
        :disabled="disabled"
        :checked="v"
        @change="set"
      />
      <label :for="id" class="radio__label" v-html="label" />
	</div>
</template>

<script>
import utils from "@/utils"

export default {
	name:  "Checkbox",
	id: null,

	props: {
		label:    {
			type:    String,
			default: "",
		},
		disabled: {
			type:    Boolean,
			default: false,
		},
    value: {
      default: false
    }
	},
	data() {
		return {
		  id: utils.uniqueHashGen( "dom_" )
		};
	},
	methods: {
    set( event ) {
			this.$emit( "input", event.target.checked );
		}
	},
  computed: {
	  v() {
	    return !!this.value;
    }
  }
};
</script>

<style scoped>
  .checkbox {
	  display: inline-block;
  }

	.checkbox label {
    display: inline-block;
    position: relative;
		font-size: 1em;
		line-height: 1em;
		height: 1.1em;
		padding-left: 1.5em;
		cursor: pointer;
  }

  .checkbox label:before {
    position: absolute;
    content: "";
  }

  .checkbox label:before,
  .checkbox label:after {
    content: "";
    position: absolute;
    border-radius: 0.2em;
    left: 0;
    top: 0;
    width: 1.1em;
    height: 1.1em;
    margin: auto;
    box-sizing: border-box;
  }

  .checkbox label:before {
    z-index: 1;
    background-color: #FFFFFF;
    border: 2px solid #4D4D4D;
    transition: opacity .35s ease;
  }

  .checkbox label:after {
    z-index: 2;
    transition: transform .35s ease;
    background-image: url("data:image/svg+xml,%3Csvg width='14' height='10' viewBox='0 0 14 10' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath fill-rule='evenodd' clip-rule='evenodd' d='M5 10L0 5.19231L1.4 3.84615L5 7.30769L12.6 0L14 1.34615L5 10Z' fill='%23FFFFFF'/%3E%3C/svg%3E%0A");
    background-repeat: no-repeat;
    background-position: 50% 50%;
    background-size: 0.8em;
    transform: scale(0);
  }

	.checkbox input {
		position: absolute;
		left: -9999px;
		top: 0;
		display: none;
  }

	.checkbox input:checked + label:before {
    background-color: #0081CA;
    border-color: #0081CA;
  }
	.checkbox input:checked + label:after {
		transform: scale(1);
  }

  .checkbox input:checked + label:hover:before,
  .checkbox input:checked + label:focus:before,
  .checkbox label:hover:before,
  .checkbox label:focus:after {
    border-color: #4D4D4D;
  }
</style>